"use strict";

import $ from "jquery";
import "slick-carousel";
import "slick-carousel/slick/slick.css";

var carslArgs = {
    autoplay: false,
    autoplaySpeed: 3600,
    speed: 600,
    pauseOnHover: true,
    arrows: false,
    prevArrow:
        '<button type="button" class="slick-prev"><i class="fa fa-angle-left"></i><span class="sr-only">Anterior</span></button>',
    nextArrow:
        '<button type="button" class="slick-next"><i class="fa fa-angle-right"></i><span class="sr-only">Próximo</span></button>',
};

(function () {
    configCarousel();
})();

function configCarousel(els) {
    if (typeof $els != "undefined") {
        $(els).slick(carslArgs);
    } else {
        var args;

        args = carslArgs;
        args.arrows = true;
        $(".carsl:not([ui-carsl]").slick(args);

        args = carslArgs;
        args.arrows = true;
        args.autoplay = true;
        $('.carsl[ui-carsl="hero"]').slick(args);

        args = carslArgs;
        args.arrows = false;
        args.asNavFor = '[ui-carsl="nav"]';
        $('.gallery [ui-carsl="for"]').slick(args);

        args = carslArgs;
        args.asNavFor = '[ui-carsl="for"]';
        args.slidesToShow = 4;
        args.focusOnSelect = true;
        $('.gallery [ui-carsl="nav"]').slick(args);

        args = carslArgs;
        args.autoplay = true;
        args.pauseOnHover = false;
        args.speed = 600;
        args.centerMode = true;
        args.slidesToShow = 1;
        args.variableWidth = true;
        $("#localizacao .images").slick(args);
    }
}

window.configCarousel = configCarousel;



// WEBPACK FOOTER //
// ./js/carousel.js